<script>
	let y
	let previousY
	let expandNav
	let noShadow

	// get old navbar html and remove - will be replace w/ svelte component
	let navbar = document.getElementById('navbar_wrap')
	let navbarHTML = navbar.innerHTML
	navbar.parentElement.removeChild(navbar)

	function onScroll() {
		previousY = y
	}

	$: stickyNav = y > 10

	$: if (
		!window.cancelNavExpand &&
		window.innerWidth > 800 &&
		previousY > y + 25
	) {
		expandNav = true
	} else if (previousY < y) {
		expandNav = false
	}

	setTimeout(() => {
		noShadow = window.cancelNavExpand
	}, 9)
</script>

<svelte:window bind:scrollY={y} on:scroll={onScroll} />

<div
	class="navbar-wrap"
	id="navbar_wrap"
	class:sticky-nav={stickyNav}
	class:expand-nav={expandNav}
	class:no-shadow={noShadow}>
	{@html navbarHTML}
</div>
